import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Reader question: How do you learn programming topics?",
  "description": "Nader writes in worried that he started coding too late and his progress is too slow. Here's my response.",
  "published": "2020-11-01T00:00:00.000Z",
  "hero": "./img/screenshot-1604289133375.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Nader writes in worried that he started coding too late and his progress is too slow. Here's my response.`}</p>
    <p>{`First: it’s never too late! Nice thing about programming is that the later you start, the more annoying problems others have solved for you.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Do you use a specific productivity system and workflow when you are watching a course or read a book?`}</p>
    </blockquote>
    <p>{`My studying skill is not the best. Never did well on exams and tests of skill. But I’ve picked up a couple of tricks from speed reading back in college.`}</p>
    <p>{`I try to have a specific problem I want to solve. A goal.`}</p>
    <p>{`That helps ground your learning and provides motivation. Looking for an answer to a specific question helps with focus and it helps you notice the useful details.`}</p>
    <p>{`Then I start with a broad map.`}</p>
    <p>{`Find articles, courses, books, even wikipedia is great. Anything that gives you a broad idea of what’s out there. Basic concepts, general approaches, etc.`}</p>
    <p>{`Like a scaffolding with lots of holes. Sometimes known as “the forest”`}</p>
    <p>{`After that jump into solving problems and building apps. When you encounter a missing gap, look for a deep dive resource.`}</p>
    <p>{`This is where docs come into play, articles on specific topics, sometimes you get so in the weeds you gotta dig through the source code of a library.`}</p>
    <p>{`You could say my framework is a random walk driven by a central project or idea I’m chasing.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Do you take notes as you watch/read or you finish a chapter/module and then start practicing or reviewing?`}</p>
    </blockquote>
    <p>{`When reading for broad understanding, I let books wash over me. Preferrably in audiobook.`}</p>
    <p>{`If somethign specific sticks out, I write it down as a tweet or a blog. After writing things down I rarely have to look at my notes again. Kinda just sticks.`}</p>
    <p>{`For resources that I’m reading to solve a specific problem ... I’ve never finished. Usually I run off and start experimenting long before the end. Then refer back to the resource when I get stuck on something.`}</p>
    <blockquote>
      <p parentName="blockquote">{`How do you remember technical concepts for long-term use?`}</p>
    </blockquote>
    <p>{`I try not to memorize anything.`}</p>
    <p>{`You can look up details with google as long as you remember a rough map of where to find them. If it doesn’t stick on its own that means it wasn’t useful yet. When it’s useful and solves a problem, it sticks around.`}</p>
    <p>{`Or as I like to say: `}<em parentName="p">{`"The good shit stays"`}</em></p>
    <blockquote>
      <p parentName="blockquote">{`How much does it take you to finish a course or read a book? (I'd like to know a metric to see how fast I should learn)`}</p>
    </blockquote>
    <p>{`Depends on the book or course.`}</p>
    <p>{`There's business courses I’ve been poking at for 2+ years as I encounter new challenges and refer back. Or use them as a guide every time I’m doing the thing they’re teaching.`}</p>
    <p>{`Then there’s audiobooks that I breeze through in 2 or 3 afternoons and their underlying idea sticks. But I won’t even know which book it came from.`}</p>
    <p>{`Some 1000+ word articles I scroll through in 2 minutes, read 3 paragraphs in the middle, and use that to solve a problem. Don’t even read the whole thing :)`}</p>
    <blockquote>
      <p parentName="blockquote">{`How do you get better at a skill when facing challenges and frustration?`}</p>
    </blockquote>
    <p>{`Remind yourself that it’s all part of the process. You’ll never learn how to bomb a hill on a longboard without a gnarly new scar or two.`}</p>
    <blockquote>
      <p parentName="blockquote">{`How do you learn a new tool/concepts in computer science?What is your approach to improve your skills in terms of practice?`}</p>
    </blockquote>
    <p>{`Use it. Solve problems. Play around.`}</p>
    <p>{`Programming is a lot like cooking: you can’t learn squat by reading. You gotta get your hands dirty. Practical hands-on experience is all that matters.`}</p>
    <p>{`And hey, I learned about functions and procedures when my programs couldn’t jump more than 4096 lines in Pascal when I was 12 or 13. I thought `}<em parentName="p">{`“what the fuck this is dumb, surely there’s a way to write bigger software than this!”`}</em>{` and dug into the help files.`}</p>
    <p>{`My English wasn’t great back then so it was interesting. Helped me learn lots of English! And I learned that yes indeed you can write programs longer than 2`}{`*`}{`4096 lines.`}</p>
    <blockquote>
      <p parentName="blockquote">{`What separates excellent developers from the rest in your opinion, when you can get things done using nmp packages nowadays with so much abstraction from writing codes?`}</p>
    </blockquote>
    <p>{`Why would using npm packages be a bad thing? Your job is to solve problems. Users don’t care how 😉`}</p>
    <p>{`Excellent developers know when a solved problem isn’t worth solving again. There’s enough domain- and problem- specific details that only you can solve.`}</p>
    <p>{`Fundamentally I encourage you to just try. Don’t worry about learning everything. Learn enough to get started and go from there.`}</p>
    <p>{`Cheers,`}<br />{`
~Swizec`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      